import { ClientSetting } from '../types/client.enums'

export const CLIENT_SETTINGS: { [id: number]: { [key: number]: ClientSetting } } = {
  3000: {
    1080: ClientSetting.CallOffView,
    1152: ClientSetting.MyShipment,
    1153: ClientSetting.MyShipmentValue,
    2001: ClientSetting.ServiceRequest,
    2011: ClientSetting.ServiceRequestExtendAccessPointDays,
    2013: ClientSetting.ServiceRequestChangeName,
    2014: ClientSetting.ServiceRequestChangeAddress,
    2015: ClientSetting.ServiceRequestChangePhone,
    2016: ClientSetting.ServiceRequestChangeEmail,
    2018: ClientSetting.ServiceRequestCancelShipment,
    2019: ClientSetting.ServiceRequestChangeDoorAccessCode,
    2021: ClientSetting.ServiceRequestLeaveOutsideDoor,
    2022: ClientSetting.ServiceRequestKnockOnDoor,
    2023: ClientSetting.ServiceRequestNoIdRequirement,
    2024: ClientSetting.ServiceRequestMessageToDriver,
    2025: ClientSetting.ServiceRequestChangeLockerLocation,
    2026: ClientSetting.ServiceRequestNewDeliveryAttempt,
    2502: ClientSetting.DispatchDate,
  },
  3300: {
    1080: ClientSetting.CallOffView,
    1151: ClientSetting.MySelection,
    1152: ClientSetting.MyShipment,
    1153: ClientSetting.MyShipmentValue,
    1176: ClientSetting.ProductPanel,
    1181: ClientSetting.ContextMenu,
    1182: ClientSetting.ContextMenuSendMessage,
    1183: ClientSetting.ContextMenuServiceRequest,
    1184: ClientSetting.ContextMenuShowRelated,
    1186: ClientSetting.ContextMenuActions,
    1188: ClientSetting.ContextMenuEditInformation,
    1190: ClientSetting.ContextMenuServices,
    2001: ClientSetting.ServiceRequest,
    2011: ClientSetting.ServiceRequestExtendAccessPointDays,
    2013: ClientSetting.ServiceRequestChangeName,
    2014: ClientSetting.ServiceRequestChangeAddress,
    2015: ClientSetting.ServiceRequestChangePhone,
    2016: ClientSetting.ServiceRequestChangeEmail,
    2018: ClientSetting.ServiceRequestCancelShipment,
    2019: ClientSetting.ServiceRequestChangeDoorAccessCode,
    2021: ClientSetting.ServiceRequestLeaveOutsideDoor,
    2022: ClientSetting.ServiceRequestKnockOnDoor,
    2023: ClientSetting.ServiceRequestNoIdRequirement,
    2024: ClientSetting.ServiceRequestMessageToDriver,
    2025: ClientSetting.ServiceRequestChangeLockerLocation,
    2026: ClientSetting.ServiceRequestNewDeliveryAttempt,
    2502: ClientSetting.DispatchDate,
  },
  4000: {
    1080: ClientSetting.CallOffView,
    1152: ClientSetting.MyShipment,
    1153: ClientSetting.MyShipmentValue,
    2001: ClientSetting.ServiceRequest,
    2011: ClientSetting.ServiceRequestExtendAccessPointDays,
    2013: ClientSetting.ServiceRequestChangeName,
    2014: ClientSetting.ServiceRequestChangeAddress,
    2015: ClientSetting.ServiceRequestChangePhone,
    2016: ClientSetting.ServiceRequestChangeEmail,
    2018: ClientSetting.ServiceRequestCancelShipment,
    2019: ClientSetting.ServiceRequestChangeDoorAccessCode,
    2021: ClientSetting.ServiceRequestLeaveOutsideDoor,
    2022: ClientSetting.ServiceRequestKnockOnDoor,
    2023: ClientSetting.ServiceRequestNoIdRequirement,
    2024: ClientSetting.ServiceRequestMessageToDriver,
    2025: ClientSetting.ServiceRequestChangeLockerLocation,
    2026: ClientSetting.ServiceRequestNewDeliveryAttempt,
    2502: ClientSetting.DispatchDate,
  },
  4300: {
    1080: ClientSetting.CallOffView,
    1751: ClientSetting.MySelection,
    1152: ClientSetting.MyShipment,
    1153: ClientSetting.MyShipmentValue,
    1776: ClientSetting.ProductPanel,
    1781: ClientSetting.ContextMenu,
    1782: ClientSetting.ContextMenuSendMessage,
    1783: ClientSetting.ContextMenuServiceRequest,
    1784: ClientSetting.ContextMenuShowRelated,
    1786: ClientSetting.ContextMenuActions,
    1788: ClientSetting.ContextMenuEditInformation,
    1790: ClientSetting.ContextMenuServices,
    2001: ClientSetting.ServiceRequest,
    2011: ClientSetting.ServiceRequestExtendAccessPointDays,
    2013: ClientSetting.ServiceRequestChangeName,
    2014: ClientSetting.ServiceRequestChangeAddress,
    2015: ClientSetting.ServiceRequestChangePhone,
    2016: ClientSetting.ServiceRequestChangeEmail,
    2018: ClientSetting.ServiceRequestCancelShipment,
    2019: ClientSetting.ServiceRequestChangeDoorAccessCode,
    2021: ClientSetting.ServiceRequestLeaveOutsideDoor,
    2022: ClientSetting.ServiceRequestKnockOnDoor,
    2023: ClientSetting.ServiceRequestNoIdRequirement,
    2024: ClientSetting.ServiceRequestMessageToDriver,
    2025: ClientSetting.ServiceRequestChangeLockerLocation,
    2026: ClientSetting.ServiceRequestNewDeliveryAttempt,
    2502: ClientSetting.DispatchDate,
  },
}
